module.exports = __webpack_public_path__ + "curriculum-04.png?acc4e9c9ccd93cc38cc6d2463dc2f486";


//////////////////
// WEBPACK FOOTER
// ./src/assets/curriculum-04.png
// module id = 213
// module chunks = 0